import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/bank-account-integrations/{bankAccountIntegrationId}']['PUT'];
type Input = THIS_API['params'] & THIS_API['body'];
type Output = THIS_API['response'];

const updateBankStatementOrganizerRequest = async ({ bankAccountIntegrationId, updates }: Input): Promise<Output> => {
  const response = await noodleApiClient.put(`/bank-account-integrations/${bankAccountIntegrationId}`, { updates });
  return response.data;
};

export default updateBankStatementOrganizerRequest;
